import glideCarouselModule from "../glideCarouselModule";

const glideConstants = {
    options: {
        breakpoints: {
            479: {
                perView: 3
            },
            766: {
                perView: 5
            },
            1023: {
                perView: 7
            }
        },
        startAt: 0,
        perView: 7
    },

    breakpointWidth: [479, 766, 1023],

    glideControl: {
        defaultNumItemsToMove: 7,
        currentNumSlidesToMove: 7,
        currentPageNumber: 0,
        disableLeftMove: false,
        disableRightMove: false
    }
}

glideCarouselModule.constant("glideConstants", glideConstants);

export default glideConstants;